export { NameAvatar as ContactAvatar } from '@tinycld/core/components/NameAvatar'
